import Hero from "./Hero"
import TextImage from "./TextImage"
import ProductSlider from "./ProductSlider"
import ContentBlock from "./ContentBlock"
import IconGrid from "./IconGrid"
import ReviewSlider from "./ReviewSlider"
import ReferenceSlider from "./ReferenceSlider"
import CTA from "./CTA"
import TextImageGrid from "./TextImageGrid"
import LogoGrid from "./LogoGrid"
import Info from "./Info"
import FAQ from "./FAQ"
import ContactForm from "./forms/Contact"
import Wysiwyg from "./Wysiwyg"
import Employees from "./Employees"

const DynamicContent = ({ content }) => {
  const dynamic_content = content?.dynamic_content || null
  const contentTypes = {
    Set_DynamicContent_HeroSet: Hero,
    Set_DynamicContent_ContentSet: ContentBlock,
    Set_DynamicContent_TextImageSet: TextImage,
    Set_DynamicContent_IconGridSet: IconGrid,
    Set_DynamicContent_ProductSliderSet: ProductSlider,
    Set_DynamicContent_ReviewSliderSet: ReviewSlider,
    Set_DynamicContent_CtaSet: CTA,
    Set_DynamicContent_TextImageGridSet: TextImageGrid,
    Set_DynamicContent_LogoGridSet: LogoGrid,
    Set_DynamicContent_ReferenceSliderSet: ReferenceSlider,
    Set_DynamicContent_InfoSet: Info,
    Set_DynamicContent_FaqSet: FAQ,
    Set_DynamicContent_ContactForm: ContactForm,
    Set_DynamicContent_WysiwygSet: Wysiwyg,
    Set_DynamicContent_EmployeesSet: Employees,
  }

  return (
    <>
      {dynamic_content?.map((data, i) => {
        const Component = contentTypes[data?.__typename]
        if (!Component) return null

        return <Component key={i} data={data} tabIndex="0" />
      })}
    </>
  )
}

export default DynamicContent
